import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

interface SeriesConfig {
  dataKey: string;
  label: string;
  color: string;
}

interface StackedAreaChartProps<T extends Record<string, unknown>> {
  data: T[];
  series: SeriesConfig[];
  xKey?: string;
  height?: number;
  emptyMessage?: string;
}

export function StackedAreaChart<T extends Record<string, unknown>>({
  data,
  series,
  xKey = 'date',
  height = 240,
  emptyMessage = 'No data for this period',
}: StackedAreaChartProps<T>) {
  if (data.length === 0) {
    return (
      <div
        className="flex items-center justify-center text-sm text-muted-foreground bg-muted/30 rounded-md"
        style={{ height }}
      >
        {emptyMessage}
      </div>
    );
  }
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={data} margin={{ top: 10, right: 16, bottom: 8, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="currentColor" opacity={0.1} />
        <XAxis dataKey={xKey} tick={{ fontSize: 11 }} stroke="currentColor" opacity={0.6} />
        <YAxis tick={{ fontSize: 11 }} stroke="currentColor" opacity={0.6} />
        <Tooltip
          contentStyle={{
            background: 'hsl(var(--background))',
            border: '1px solid hsl(var(--border))',
            borderRadius: 6,
            fontSize: 12,
          }}
        />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        {series.map((s) => (
          <Area
            key={s.dataKey}
            type="monotone"
            dataKey={s.dataKey}
            name={s.label}
            stackId="1"
            stroke={s.color}
            fill={s.color}
            fillOpacity={0.6}
          />
        ))}
      </AreaChart>
    </ResponsiveContainer>
  );
}
